import { render, staticRenderFns } from "./tableLayoutTh.vue?vue&type=template&id=1208cf06&"
import script from "./tableLayoutTh.vue?vue&type=script&lang=js&"
export * from "./tableLayoutTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports